import React, { ChangeEvent } from 'react';

import {
  CmBox,
  CmButton,
  CmFlex,
  CmFormErrorMessage,
  CmLabelAndInput,
  CmLabelWithQuestionIconAndInput,
  CmLabelWithQuestionIconAndSingleReactSelect,
  CmLongLoading,
  CmStack,
  ReactSingleSelectInput,
  SelectForm,
} from '@/components/uiParts';
import { SidebarWrapper } from '@/pages/store-management/components/Layout/SidebarWrapper';
import { CreateAssociateBrandModal } from '@/pages/store-management/master-stores/components/Modal/CreateAssociateBrandModal';
import { masterStoreForm } from '@/pages/store-management/master-stores/service';
import { MasterStoreFormError } from '@/pages/store-management/master-stores/validate';

const PREFIX = 'sidebar-';

type Props = {
  error: MasterStoreFormError;
  isLoading: boolean;
  IsOpenCreateAssociateBrandModal: boolean;
  isSidebarOpen: boolean;
  masterStoreName: string;
  masterStoreBusinessNumber: string;
  masterStoreBusinessName: string;
  associateBrandSelectInput: ReactSingleSelectInput;
  authStoreSelectInput: ReactSingleSelectInput;
  handleInputMasterStoreName: (e: ChangeEvent<HTMLInputElement>) => void;
  handleInputMasterStoreBusinessNumber: (
    e: ChangeEvent<HTMLInputElement>
  ) => void;
  handleInputMasterStoreBusinessName: (
    e: ChangeEvent<HTMLInputElement>
  ) => void;
  handleCloseSidebar: () => void;
  addCreatedAssociateBrandToSelectBox: (associateBrand: SelectForm) => void;
  handleCloseCreateAssociateBrandModal: () => void;
  handleCreateStore: () => Promise<void>;
};

export const MasterStoreNewSidebarForm: React.FC<Props> = ({
  error,
  isLoading,
  IsOpenCreateAssociateBrandModal,
  isSidebarOpen,
  masterStoreName,
  masterStoreBusinessNumber,
  masterStoreBusinessName,
  associateBrandSelectInput,
  handleInputMasterStoreName,
  handleInputMasterStoreBusinessNumber,
  handleInputMasterStoreBusinessName,
  authStoreSelectInput,
  handleCloseSidebar,
  addCreatedAssociateBrandToSelectBox,
  handleCloseCreateAssociateBrandModal,
  handleCreateStore,
}) => {
  const isDisabledCreateStoreButton = [
    masterStoreName === '',
    authStoreSelectInput.value?.value === '',
    associateBrandSelectInput.value?.value === '',
  ].some((isError) => isError);
  return (
    <SidebarWrapper
      {...{
        isSidebarOpen,
        handleCloseSidebar,
      }}
    >
      <CmBox>
        <CmStack spacing="5px">
          <CmLabelWithQuestionIconAndInput
            isRequired
            isInvalid={error.name.isError}
            id={PREFIX + masterStoreForm.name.key}
            label={masterStoreForm.name.label}
            fontWeight="bold"
            value={masterStoreName}
            onChange={handleInputMasterStoreName}
            placeholder="海鮮居酒屋 日本橋堀留町店"
            question={masterStoreForm.name.question}
          >
            <CmFormErrorMessage>{error.name.message}</CmFormErrorMessage>
          </CmLabelWithQuestionIconAndInput>
          <CmLabelWithQuestionIconAndSingleReactSelect
            fontWeight="bold"
            label={masterStoreForm.authStoreName.label}
            isRequired
            isInvalid={error.authStore.isError}
            name={PREFIX + masterStoreForm.authStoreName.key}
            closeMenuOnSelect
            isClearable={false}
            singleSelectInput={authStoreSelectInput}
            error={
              <CmFormErrorMessage>{error.authStore.message}</CmFormErrorMessage>
            }
            question={masterStoreForm.authStoreName.question}
          />
          <>
            <CmLabelWithQuestionIconAndSingleReactSelect
              fontWeight="bold"
              label={masterStoreForm.associatebrandName.label}
              name={PREFIX + masterStoreForm.associatebrandName.key}
              isRequired
              isInvalid={error.associateBrand.isError}
              closeMenuOnSelect
              isClearable={false}
              singleSelectInput={associateBrandSelectInput}
              error={
                <CmFormErrorMessage>
                  {error.associateBrand.message}
                </CmFormErrorMessage>
              }
              question={masterStoreForm.associatebrandName.question}
            />
            <CreateAssociateBrandModal
              {...{
                addCreatedAssociateBrandToSelectBox,
                IsOpenCreateAssociateBrandModal,
                handleCloseCreateAssociateBrandModal,
              }}
            />
          </>

          <CmLabelAndInput
            id={PREFIX + masterStoreForm.businessNumber.key}
            label={masterStoreForm.businessNumber.label}
            isInvalid={error.businessNumber.isError}
            fontWeight="bold"
            value={masterStoreBusinessNumber}
            onChange={handleInputMasterStoreBusinessNumber}
            placeholder="T01234567890123"
          />
          <CmLabelWithQuestionIconAndInput
            id={PREFIX + masterStoreForm.businessName.key}
            label={masterStoreForm.businessName.label}
            isInvalid={error.businessName.isError}
            fontWeight="bold"
            value={masterStoreBusinessName}
            onChange={handleInputMasterStoreBusinessName}
            placeholder="株式会社〇〇"
            question={masterStoreForm.businessName.question}
          >
            <CmFormErrorMessage>
              {error.businessName.message}
            </CmFormErrorMessage>
          </CmLabelWithQuestionIconAndInput>
          <CmBox>
            <CmFlex flexDirection="row-reverse">
              {/*
               // @ts-ignore TS2590 */}
              <CmButton
                mt="10px"
                onClick={handleCreateStore}
                isDisabled={isDisabledCreateStoreButton}
              >
                登録
              </CmButton>
            </CmFlex>
          </CmBox>
        </CmStack>
        {isLoading && <CmLongLoading />}
      </CmBox>
    </SidebarWrapper>
  );
};
